import React from 'react';
import InfoIcon from '../Icons/InfoIcon';
import VoxelTooltipShort from '../Tooltip/VoxelTooltipShort';

export interface VoxelInfoProps {
  tooltip: string;
  className?: string;
}

export const VoxelInfo: React.FC<VoxelInfoProps> = ({ tooltip, className }) => {
  return (
    <VoxelTooltipShort message={tooltip}>
      <span className={className}>
        <InfoIcon />
      </span>
    </VoxelTooltipShort>
  );
};

export default VoxelInfo;
